import { Calendar } from 'lucide-react'
import { cn } from '@/lib/utils'

interface YearSelectorProps {
  years: number[]
  selectedYear: number
  onChange: (year: number) => void
  className?: string
}

export function YearSelector({ years, selectedYear, onChange, className }: YearSelectorProps) {
  // Ensure current year is always available and years are sorted descending
  const currentYear = new Date().getFullYear()
  const allYears = [...new Set([currentYear, ...years])].sort((a, b) => b - a)

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Calendar className="h-4 w-4 text-muted-foreground" />
      <select
        value={selectedYear}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
        className="flex h-8 rounded-md border border-input bg-transparent pl-3 pr-8 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%2394a3b8%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22%2F%3E%3C%2Fsvg%3E')] bg-[length:16px] bg-[right_8px_center] bg-no-repeat"
      >
        {allYears.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  )
}
